<!--suppress ALL -->
<template>
  <div class="page">
    <div class="bg-content padding15" >
      <div>
        <el-tabs v-model="activeTab">
          <el-tab-pane label="意图包" name="意图包">
            <conf-index ref="confIndex" @showbox="toshow" v-bind:changeTabe="activeTab"></conf-index>
          </el-tab-pane>
          <el-tab-pane label="意图配置" name="意图配置">
            <detail-index ref="detailIndex" @showbox="toshow" v-bind:changeTabe="activeTab"></detail-index>
          </el-tab-pane>
          <el-tab-pane label="意图规则" name="意图规则">
            <con-index ref="conIndex" v-bind:changeTabe="activeTab"></con-index>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import confIndex from './conf/conf_index';
import detailIndex from './detail/detail_index';
import conIndex from './condition/con_index';

export default {
  data() {
    return {
      activeTab: '意图包'
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      sessionStorage.removeItem('changeConfId');
      sessionStorage.removeItem('changeDetailId');
      sessionStorage.removeItem('intentionConfName');
    },
    toshow(activeTab) {
      this.activeTab = activeTab;
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    updateButton(row) {
      this.title = '编辑意图包';
      this.form.id = row.id;
      this.form.confName = row.confName;
      this.form.status = row.status;
      this.open = true;
    },
    handleAdd() {
      this.title = '添加意图包';
      this.form.id = null;
      this.form.confName = null;
      this.form.status = true;
      this.open = true;
    },
    // 重置
    reset() {
      this.searchReq.confName = null;
      this.searchReq.status = null;
      this.searchReq.startTime = null;
      this.searchReq.endTime = null;
    },
    currentChange(page) {
      this.searchReq.page = page;
      this.getList();
    },
    // 显示条数
    sizeChange(num) {
      this.searchReq.limit = num;
      this.getList();
    },
    submitForm() {
      if (this.form.id) {
        this.$ajax({
          method: 'post',
          url: '/intentionConf/update',
          data: this.form
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
            this.open = false;
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        });
      } else {
        this.$ajax({
          method: 'post',
          url: '/intentionConf/save',
          data: this.form
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
            this.open = false;
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        });
      }
    },
    cancel() {
      this.open = false;
      this.reset();
    },
    handleDelByIds() {
      this.$confirm('是否确认删除 ?', '警告', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          method: 'delete',
          url: '/intentionConf/del',
          data: this.ids
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        }).finally(() => {
          this.getList();
        });
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm(`是否确认删除条件意图包：${row.confName} ?`, '警告', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          method: 'delete',
          url: `/intentionConf/del/${row.id}`
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        }).finally(() => {
          this.getList();
        });
      });
    }
  },
  components: {
    confIndex,
    detailIndex,
    conIndex
  }
};
</script>
<style lang="less" scoped>
.sc-row {
  margin-bottom: 15px;
  .sc-row__title {
    padding: 5px 0 0 0;
    text-align: right;
    strong {
      font-weight: 600;
    }
  }
  .sc-row__content {
    .send-percent {
      margin-bottom: 5px;
      .percent {
        width: 120px;
        margin: 0 10px;
      }
    }
    .score-table {
      margin: 15px 0;
      table {
        th, td {
          text-align: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/main/collection/intention/index.vue